<template>
  <v-card class="ui-module-card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Puesto y dependencia</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <template v-if="personal.CatRamaDependencia">
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Dependencia</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="personal.CatRamaDependencia.CatDependencia.catInstancia.title"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Instancia"
                  ></v-text-field>
                  <v-text-field
                    v-model="personal.CatRamaDependencia.CatDependencia.nombre"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Nombre"
                  ></v-text-field>
                  <v-text-field
                    v-model="personal.CatRamaDependencia.ramaDependencia"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Dirección"
                  ></v-text-field>
                  <template v-if="personal.CatSubArea">
                    <v-text-field
                      v-model="personal.CatSubArea.CatArea.nombre"
                      rounded
                      readonly
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Área"
                    ></v-text-field>
                    <v-text-field
                      v-model="personal.CatSubArea.nombre"
                      rounded
                      readonly
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Sub-área"
                    ></v-text-field>
                  </template>
                  <template v-else>
                    <v-text-field
                      value=""
                      rounded
                      readonly
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Área"
                    ></v-text-field>
                    <v-text-field
                      value=""
                      rounded
                      readonly
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Sub-área"
                    ></v-text-field>
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </template>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Puesto</div>
          </v-col>
          <v-col cols="4" v-if="personal.CatPuestoDependencia">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-if="personal.CatPuestoDependencia.CatTipoPuesto"
                  v-model="personal.CatPuestoDependencia.CatTipoPuesto.title"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Tipo de Puesto"
                ></v-text-field>
                <v-text-field
                  v-else
                  value=""
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Tipo de Puesto"
                ></v-text-field>
                <v-text-field
                  v-model="personal.CatPuestoDependencia.catPuesto.puesto"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Puesto"
                ></v-text-field>
                <v-text-field
                  v-if="isAllowedToSeeRestrictedFields"
                  v-model="personal.plaza"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Plaza"
                ></v-text-field>
                <v-text-field
                  v-if="isAllowedToSeeRestrictedFields"
                  v-model="personal.capturo"
                  rounded
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Nombramiento"
                ></v-text-field>
                <v-text-field
                  v-if="personal.CatTurno"
                  v-model="personal.CatTurno.title"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Turno"
                ></v-text-field>
                <v-text-field
                  v-else
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Turno"
                ></v-text-field>
                <v-textarea
                  v-model="personal.CatPuestoDependencia.funciones"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="transparent"
                  color="secondary"
                  label="Funciones"
                  no-resize
                  rows="4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Datos de nuevo ingreso</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="ingresoAspirante"
                  label="Este elemento es de nuevo ingreso"
                  color="secondary"
                  hide-details
                  class="mt-0"
                  :loading="updatingAspirante"
                  @change="handleIngresoAspiranteChange"
                ></v-checkbox>
                <v-checkbox
                  v-model="reclutadoPolicial"
                  label="Este elemento inició como aspirante y fue reclutado como policía"
                  color="secondary"
                  :loading="updatingReclutado"
                  @change="handleReclutadoPolicialChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Pase de lista</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedSede"
                  rounded
                  filled
                  dense
                  :items="sedes"
                  item-value="id"
                  background-color="transparent"
                  color="secondary"
                  label="Sede"
                  @change="onSedeChange"
                >
                  <template v-slot:selection="{ item }">
                    {{ item.nombre || item.title || item.sede || 'Sin nombre' }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ item.nombre || item.title || item.sede || 'Sin nombre' }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="personal.fk_idSubsede"
                  rounded
                  filled
                  dense
                  :items="subsedesFiltradas"
                  item-value="id"
                  :item-text="getSubsedeLabel"
                  background-color="transparent"
                  color="secondary"
                  label="Subsede"
                  :disabled="!selectedSede"
                  :hint="!selectedSede ? 'Selecciona primero una sede' : ''"
                  persistent-hint
                >
                  <template v-slot:selection="{ item }">
                    {{ getSubsedeLabel(item) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ getSubsedeLabel(item) }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Fecha de alta</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12" class="text-right">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Fecha de alta"
                      :value="fechaAlta"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="transparent"
                    />
                  </template>
                  <v-date-picker v-model="selectedDate" @input="menu = false" no-title></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <template v-if="isAllowedToSeeRestrictedFields">
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Grado Homologado</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="personal.fk_idCatGradoHomologado"
                    rounded
                    filled
                    dense
                    :items="tipoGradoHomologado"
                    item-value="id"
                    item-text="title"
                    background-color="transparent"
                    color="secondary"
                    label="Grado Homologado"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Número de empleado</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="personal.unidadAnalisisTactico"
                    rounded
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Número de empleado"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Turno</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="nuevoTurno"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    :items="filteredTurnos"
                    item-value="id"
                    item-text="title"
                    item-color="secondary"
                    label="Turno"
                    placeholder="Selecciona un turno"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
          </template>
          <v-col cols="12" class="text-right" v-if="!isComisariaProfile">
            <TextButton :loading="loadingGuardar" color="secondary" class="primary--text mb-3" @click="saveAll">
              Guardar Cambios
            </TextButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import DateAdapter from '@/utils/DateAdapter'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseTextInput from '../base/BaseTextInput.vue'
import TextButton from '../base/TextButton.vue'
import { PERFILES } from '@/perfiles.js'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '@/const'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'

export default {
  components: {
    BaseTextInput,
    TextButton,
  },

  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      loadingGuardar: false,
      menu: false,
      selectedDate: this.personal.fechaIngresoEdoFza
        ? new DateAdapter(this.personal.fechaIngresoEdoFza, API_DATE_FORMAT).toUiSupportedFormat()
        : null,
      PERFILES,
      updatingAspirante: false,
      updatingReclutado: false,
      ingresoAspirante: false,
      reclutadoPolicial: false,
      selectedSede: null,
      subsedesFiltradas: [],
      nuevoTurno: null,
      initialSedeId: null,
      initialSubsedeId: null,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil', nombre: 'getNombre' }),
    ...mapGetters('subsede', { subsedes: 'getSubsedes' }),
    ...mapGetters('sede', { sedes: 'getSedes' }),
    ...mapGetters('gradoHomologado', { tipoGradoHomologado: 'getGradoHomologado' }),
    ...mapGetters('turnos', { turnos: 'getTurnos' }),

    fechaAlta() {
      if (!this.selectedDate) {
        return ''
      }

      return new DateAdapter(this.selectedDate, VUETIFY_DATE_FORMAT).toHumanReadable()
    },

    filteredTurnos() {
      return this.turnos
    },

    isAllowedToSeeRestrictedFields() {
      const allowedProfiles = [
        PERFILES['ADMINSITRADOR GENERAL'],
        PERFILES['Recursos Humanos'],
        PERFILES['RH_ADMINISTRADOR'],
        PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
        PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
        PERFILES['RH_REGISTRO DE PERSONAL'],
        PERFILES['DP_ADMINISTRADOR'],
        PERFILES['DP_CONTROL_EVALUACIONES'],
        PERFILES['DP_CONDECORACIONES_EVALUACIONES'],
        PERFILES['COMISARIA_CAPTURA'],
        PERFILES['COMISARIA_SUPERVISOR'],
      ]

      return allowedProfiles.includes(this.perfil)
    },
    isComisariaProfile() {
      return [PERFILES.COMISARIA_CAPTURA, PERFILES.COMISARIA_SUPERVISOR].includes(this.perfil)
    },
  },

  watch: {
    personal: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.ingresoAspirante = newVal.ingresoAspirante || false
          this.reclutadoPolicial = newVal.reclutadoPolicial || false

          this.initialSubsedeId = newVal.fk_idSubsede || null

          if (newVal.CatTurno && newVal.CatTurno.id) {
            this.nuevoTurno = newVal.CatTurno.id
          }

          if (newVal.fk_idSubsede && this.subsedes.length > 0) {
            const subsede = this.subsedes.find((s) => s.id === newVal.fk_idSubsede)
            if (subsede && subsede.fk_idSede) {
              this.selectedSede = subsede.fk_idSede
              this.loadSubsedesBySede(subsede.fk_idSede)
              if (!this.initialSedeId) {
                this.initialSedeId = subsede.fk_idSede
              }
            }
          }
        }
      },
    },
    subsedes: {
      immediate: true,
      handler(newVal) {
        if (this.initialSedeId || !this.initialSubsedeId || !newVal?.length) return
        const subsede = newVal.find((s) => s.id === this.initialSubsedeId)
        if (subsede?.fk_idSede) {
          this.initialSedeId = subsede.fk_idSede
        }
      },
    },
  },
  async mounted() {
    await Promise.all([this.fetchGradoHomologado(), this.fetchSedes(), this.fetchSubsedes(), this.fetchTurnos()])
  },

  methods: {
    ...mapActions('personal', ['updatePersonal', 'updateTurnoPersonal']),
    ...mapActions('gradoHomologado', ['fetchGradoHomologado']),
    ...mapActions('subsede', ['fetchSubsedes', 'fetchSubsedesBySede']),
    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('turnos', ['fetchTurnos']),
    ...mapActions('aspirantes', ['updateAspiranteStatus', 'updateAspiranteReclutedToPolicia']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification']),

    async onSedeChange(sedeId) {
      this.personal.fk_idSubsede = null

      if (!sedeId) {
        this.subsedesFiltradas = []
        return
      }

      await this.loadSubsedesBySede(sedeId)
    },

    async loadSubsedesBySede(sedeId) {
      try {
        await this.fetchSubsedesBySede({ id: sedeId })

        this.subsedesFiltradas = this.subsedes.filter((subsede) => subsede.fk_idSede === sedeId)
      } catch (error) {
        console.error('Error al cargar subsedes:', error)
        this.subsedesFiltradas = []
      }
    },

    async saveAll() {
      try {
        this.loadingGuardar = true

        const cambioSede = this.getCambioSedePayload()

        const { Contacto, Direccion, ...personalSinContacto } = this.personal

        const payload = {
          ...personalSinContacto,
          fk_idCatGradoHomologado: this.personal.fk_idCatGradoHomologado,
          fechaIngresoEdoFza: this.selectedDate
            ? new DateAdapter(this.selectedDate, VUETIFY_DATE_FORMAT).toApiSupportedFormat()
            : this.personal.fechaIngresoEdoFza,
          unidadAnalisisTactico: this.personal.unidadAnalisisTactico,
          fk_idSubsede: this.personal.fk_idSubsede,
        }

        await this.updatePersonal(payload)

        if (this.nuevoTurno && this.nuevoTurno !== this.personal.CatTurno?.id) {
          await this.updateTurnoPersonal({
            idPersonal: this.personal.idPersonal,
            fk_idCatTurno: this.nuevoTurno,
          })
        }

        if (cambioSede && cambioSede.hasChanges) {
          await this.sendNotification(cambioSede)
        }

        await this.$store.dispatch('personal/fetchPersonalById', this.personal.idPersonal)

        this.initialSedeId = this.selectedSede || null
        this.initialSubsedeId = this.personal.fk_idSubsede || null

        this.SET_SNACKBAR_MESSAGE('Cambios guardados exitosamente.')
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('No fue posible guardar los cambios.')
      } finally {
        this.loadingGuardar = false
      }
    },

    getCambioSedePayload() {
      const currentSedeId = this.selectedSede || null
      const currentSubsedeId = this.personal.fk_idSubsede || null
      const initialSedeId = this.initialSedeId ?? this.getSedeIdFromSubsede(this.initialSubsedeId)
      const initialSubsedeId = this.initialSubsedeId || null

      const hasChanges = initialSedeId !== currentSedeId || initialSubsedeId !== currentSubsedeId

      return {
        hasChanges,
        initialSedeId,
        currentSedeId,
        initialSubsedeId,
        currentSubsedeId,
      }
    },

    getSedeIdFromSubsede(subsedeId) {
      if (!subsedeId) return null
      const subsede = this.subsedes.find((item) => item.id === subsedeId)
      return subsede?.fk_idSede || null
    },

    getSedeNameById(sedeId) {
      if (!sedeId) return 'Sin sede'
      const sede = this.sedes.find((item) => item.id === sedeId)
      return sede?.nombre || sede?.title || sede?.sede || 'Sin nombre'
    },

    getSubsedeNameById(subsedeId) {
      if (!subsedeId) return 'Sin comisaría'
      const subsedeFromFiltered = this.subsedesFiltradas.find((item) => item.id === subsedeId)
      if (subsedeFromFiltered) return this.getSubsedeLabel(subsedeFromFiltered)

      const subsedeFromStore = this.subsedes.find((item) => item.id === subsedeId)
      if (subsedeFromStore) return this.getSubsedeLabel(subsedeFromStore)

      const subsedeFromPersonal = this.personal?.CatSubSede
      if (subsedeFromPersonal && subsedeFromPersonal.id === subsedeId) {
        return this.getSubsedeLabel(subsedeFromPersonal)
      }

      return 'Sin comisaría'
    },

    buildCambioSedeMensaje({ initialSedeId, currentSedeId, initialSubsedeId, currentSubsedeId }) {
      const sedeAnterior = this.getSedeNameById(initialSedeId)
      const sedeNueva = this.getSedeNameById(currentSedeId)
      const comisariaAnterior = this.getSubsedeNameById(initialSubsedeId)
      const comisariaNueva = this.getSubsedeNameById(currentSubsedeId)
      const nombreResponsable = this.getResponsableNombre()
      const nombreElemento = this.getPersonalNombre()

      const cambioSede = initialSedeId !== currentSedeId
      const cambioComisaria = initialSubsedeId !== currentSubsedeId && currentSubsedeId !== null

      if (cambioSede && cambioComisaria) {
        return `El personal ${nombreResponsable} actualizó al elemento ${nombreElemento} de la sede "${sedeAnterior}" a "${sedeNueva}" y la comisaría "${comisariaAnterior}" a "${comisariaNueva}".`
      }

      if (cambioSede) {
        return `El personal ${nombreResponsable} actualizó al elemento ${nombreElemento} de la sede "${sedeAnterior}" a "${sedeNueva}".`
      }

      return `El personal ${nombreResponsable} actualizó al elemento ${nombreElemento} de la comisaría "${comisariaAnterior}" a "${comisariaNueva}".`
    },

    getResponsableNombre() {
      return this.nombre || localStorage.getItem('nombre') || 'Sin nombre'
    },

    getSubsedeLabel(item) {
      if (!item) return 'Sin comisaría'
      return item.nombre || item.title || item.sede || 'Sin comisaría'
    },

    getPersonalNombre() {
      return this.getFullName(this.personal?.Personal || this.personal)
    },

    getFullName(personal) {
      if (!personal) return 'Sin nombre'
      const nombre = personal.nombre || ''
      const segundoNombre = personal.segundoNombre || ''
      const apellidoPaterno = personal.apaterno || personal.apellidoPaterno || ''
      const apellidoMaterno = personal.amaterno || personal.apellidoMaterno || ''
      const fullName = `${nombre} ${segundoNombre} ${apellidoPaterno} ${apellidoMaterno}`.trim()
      return fullName || 'Sin nombre'
    },

    async sendNotification(payload) {
      const notification = new NotificationFactory(Notificacion).createNotification(NOTIFICATION_TYPES.CAMBIO_SEDE, {
        responsable: Number(localStorage.getItem('idPersonal')),
        afectado: this.personal.idPersonal,
        mensaje: this.buildCambioSedeMensaje(payload),
      })

      await this.createNotification(notification)
    },

    async handleIngresoAspiranteChange(value) {
      this.updatingAspirante = true
      try {
        await this.updateAspiranteStatus({ idPersonal: this.personal.idPersonal, ingresoAspirante: value })
      } catch (error) {
        if (error.response?.data?.error_code !== 500) {
          this.ingresoAspirante = !value
        }
        console.error('Error al actualizar ingreso aspirante:', error)
      } finally {
        this.updatingAspirante = false
      }
    },

    async handleReclutadoPolicialChange(value) {
      this.updatingReclutado = true
      try {
        await this.updateAspiranteReclutedToPolicia({ idPersonal: this.personal.idPersonal, reclutadoPolicial: value })
      } catch (error) {
        if (error.response?.data?.error_code !== 500) {
          this.reclutadoPolicial = !value
        }
        console.error('Error al actualizar reclutado policial:', error)
      } finally {
        this.updatingReclutado = false
      }
    },
  },
}
</script>

<style scoped>
/* Inputs, selects y textarea */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
  caret-color: var(--v-secondary-base) !important;
}

::v-deep input::placeholder,
::v-deep textarea::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* Checkbox — sin glassmorphism en el slot */
::v-deep .v-input--checkbox .v-input__slot {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .v-input--checkbox .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--checkbox.v-input--is-label-active .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Date picker */
::v-deep .v-date-picker-header {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background-color: var(--v-secondary-base) !important;
  color: white !important;
}

::v-deep .v-date-picker-table .v-btn:hover {
  background-color: rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

/* Títulos */
.text-h5,
.text-h6 {
  color: #ffffff !important;
}
</style>
